module.exports = __webpack_public_path__ + "img/watford.5239711a.png";